import { Link } from "react-router-dom";
import IstresMoiTitle from "@/components/IstresMoiTitle";
import { ISTRES_LOGO } from "@/lib/istres";
import { APP_VERSION, formatBuildDate } from "@/lib/build-info";

/**
 * Footer unifié — identique sur toutes les pages publiques et internes.
 */
export default function SiteFooter() {
  return (
    <footer className="bg-plum-900 text-cream-50" data-testid="site-footer">
      <div className="max-w-5xl mx-auto px-5 sm:px-6 lg:px-8 py-12 sm:py-14 text-center">
        <img
          src={ISTRES_LOGO}
          alt="Logo Ville d'Istres"
          className="h-24 sm:h-28 w-auto object-contain mx-auto mb-4 drop-shadow-[0_4px_24px_rgba(255,213,0,0.15)]"
          data-testid="footer-logo"
        />
        <h2 className="text-cream-50 text-[26px] sm:text-[32px] leading-none">
          <IstresMoiTitle className="text-cream-50 text-[26px] sm:text-[32px]" ampClassName="text-sun-300" />
        </h2>
        <div className="text-[10px] sm:text-[11px] font-bold uppercase tracking-[0.24em] text-cream-50/55 mt-2">
          Ville d&apos;Istres · Plateforme officielle
        </div>

        <nav
          className="mt-7 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-[13px] font-semibold text-cream-50/80"
          aria-label="Liens légaux"
        >
          <Link to="/mentions-legales" className="hover:text-sun-300" data-testid="footer-legal-mentions">Mentions légales</Link>
          <span className="text-cream-50/25">·</span>
          <Link to="/confidentialite" className="hover:text-sun-300" data-testid="footer-legal-privacy">Politique de confidentialité</Link>
          <span className="text-cream-50/25">·</span>
          <Link to="/numeros-utiles" className="hover:text-sun-300" data-testid="footer-legal-contact">Numéros utiles</Link>
          <span className="text-cream-50/25">·</span>
          <Link to="/ressources" className="hover:text-sun-300">Ressources</Link>
          <span className="text-cream-50/25">·</span>
          <Link to="/login" className="hover:text-sun-300">Se connecter</Link>
        </nav>

        <div className="mt-6 inline-flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[11px] font-mono text-cream-50/55" data-testid="footer-build-info">
          <span className="phenix-pill bg-white/10 text-cream-50/85 border-white/15 text-[10px]">v{APP_VERSION}</span>
          <span>Mis à jour le {formatBuildDate()}</span>
        </div>

        <div className="my-8 h-px bg-cream-50/15 max-w-md mx-auto" />

        <div
          className="inline-flex items-center gap-3 px-5 py-3 rounded-2xl bg-white/8 border border-white/15"
          data-testid="footer-besson"
        >
          <img
            src="https://www.google.com/s2/favicons?domain=besson-solutions.fr&sz=64"
            alt="Logo BESSON SOLUTIONS"
            className="w-8 h-8 rounded-lg bg-white p-1 object-contain"
            onError={(e) => { e.currentTarget.style.display = "none"; }}
          />
          <div className="text-left leading-tight">
            <div className="text-[10px] uppercase tracking-[0.18em] text-cream-50/55">Conçu &amp; développé par</div>
            <div className="font-display font-extrabold text-cream-50 text-[15px] tracking-wide">BESSON SOLUTIONS</div>
          </div>
        </div>

        <p className="mt-8 text-[12px] text-cream-50/55 leading-relaxed">
          © {new Date().getFullYear()} Mairie d&apos;Istres · Plateforme officielle pour habitants et commerçants.
        </p>
      </div>
    </footer>
  );
}
